import { useEffect, useState } from "react";

export default function useMobileMode() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => {
      const widthMobile = window.innerWidth <= 820;
      const coarsePointer = window.matchMedia?.("(pointer: coarse)")?.matches;
      const standalone =
        window.matchMedia?.("(display-mode: standalone)")?.matches ||
        window.navigator?.standalone === true;

      setIsMobile(widthMobile || standalone || coarsePointer);
    };

    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  return isMobile;
}
